import {
	CREATE_MOBILE_VERSION_REQUEST,
	CREATE_MOBILE_VERSION_SUCCESS,
	CREATE_MOBILE_VERSION_FAIL,
	FETCH_MOBILE_VERSIONS_REQUEST,
	FETCH_MOBILE_VERSIONS_SUCCESS,
	FETCH_MOBILE_VERSIONS_FAIL,
	UPDATE_MOBILE_VERSION_REQUEST,
	UPDATE_MOBILE_VERSION_SUCCESS,
	UPDATE_MOBILE_VERSION_FAIL,
	DELETE_MOBILE_VERSION_REQUEST,
	DELETE_MOBILE_VERSION_SUCCESS,
	DELETE_MOBILE_VERSION_FAIL,
} from "../constants/mobileVersion";

function createMobileVersionReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case CREATE_MOBILE_VERSION_REQUEST:
			return { loading: true };
		case CREATE_MOBILE_VERSION_SUCCESS:
			return { loading: false, success: true, category: action.payload };
		case CREATE_MOBILE_VERSION_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function fetchMobileVersionsReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			categoryUpdated: false,
			error: null,
			categoryDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_MOBILE_VERSIONS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_MOBILE_VERSIONS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				mobileVersions: action.payload,
			};
		case FETCH_MOBILE_VERSIONS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateMobileVersionReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null, mobileVersionUpdated: false };
	}
	switch (action.type) {
		case UPDATE_MOBILE_VERSION_REQUEST:
			return { loading: true };
		case UPDATE_MOBILE_VERSION_SUCCESS:
			return {
				...state,
				loading: false,
				mobileVersionUpdated: true,
			};
		case UPDATE_MOBILE_VERSION_FAIL:
			return {
				loading: false,
				mobileVersionUpdated: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

function deleteMobileVersionReducer(state, action) {
	if (typeof state === "undefined") {
		state = { mobileVersionDeleted: false };
	}
	switch (action.type) {
		case DELETE_MOBILE_VERSION_REQUEST:
			return { loading: true };
		case DELETE_MOBILE_VERSION_SUCCESS:
			return {
				loading: false,
				mobileVersionDeleted: true,
			};
		case DELETE_MOBILE_VERSION_FAIL:
			return {
				loading: false,
				mobileVersionDeleted: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

export {
	createMobileVersionReducer,
	fetchMobileVersionsReducer,
	updateMobileVersionReducer,
	deleteMobileVersionReducer,
};
